import { useEffect, useRef, useState } from "react";
import api, { API } from "../lib/api";
import { ClockCounterClockwise, DownloadSimple } from "@phosphor-icons/react";

// Self-audit trail: records (on mount) and lists who on the Claro team opened the
// internal Software Security section of the ClaroConsole.
export default function SecurityAccessLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const pinged = useRef(false);

  useEffect(() => {
    (async () => {
      try {
        if (!pinged.current) {
          pinged.current = true;
          await api.post("/admin/console/security-access");
        }
        const { data } = await api.get("/admin/console/security-access");
        setRows(data.access || []);
      } catch (e) {
        /* non-blocking */
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const fmt = (iso) => {
    try {
      return new Date(iso).toLocaleString();
    } catch {
      return iso;
    }
  };

  return (
    <div className="border border-slate-200 bg-white p-6" data-testid="console-access-log">
      <div className="flex items-start justify-between gap-3 mb-1">
        <div className="flex items-center gap-2">
          <ClockCounterClockwise size={20} className="text-primary" />
          <h3 className="font-display font-bold text-lg">Console Access Log</h3>
        </div>
        {rows.length > 0 && (
          <button type="button" data-testid="access-log-export-csv"
            onClick={() => window.open(`${API}/admin/console/security-access.csv`, "_blank")}
            className="flex items-center gap-1.5 border border-slate-300 px-2.5 py-1 text-xs font-semibold hover:bg-slate-50">
            <DownloadSimple size={13} /> Export CSV
          </button>
        )}
      </div>
      <p className="text-sm text-slate-500 mb-4">
        Who on the Claro team opened this internal Software Security section, and when.
      </p>
      {loading ? (
        <p className="text-sm text-slate-400">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="text-sm text-slate-400">No access recorded yet.</p>
      ) : (
        <div className="overflow-x-auto max-h-96 overflow-y-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase text-slate-500 border-b border-slate-200">
                <th className="py-2 pr-4">Who</th>
                <th className="py-2 pr-4">When</th>
                <th className="py-2">IP</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-slate-100" data-testid={`access-row-${r.id}`}>
                  <td className="py-2 pr-4">
                    <div className="font-medium">{r.actor_name}</div>
                    <div className="text-xs text-slate-400">{r.actor_email}</div>
                  </td>
                  <td className="py-2 pr-4 font-mono text-xs">{fmt(r.at)}</td>
                  <td className="py-2 font-mono text-xs text-slate-500">{r.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
